'use strict';
define([], function () {
    function controller(
        $window,
        $scope,
        $timeout,
        KeywordListService,
        TrackEventService,
        $rootScope,
        $mdToast,
        $translate,
        GoogleAdsService,
        CountriesService,
        SearchConsoleService,
    ) {
        var ctrl = this;
        var vm = $scope;
        var destroyed = false;
        var selectedLookup = Object.create(null);
        var existingLookup = Object.create(null);
        var pageSize = 100;
        var ideaReferenceLoaded = false;
        var ideaReferenceLoading = false;
        var keywordListsLoaded = false;

        vm.keywordDraft = '';
        vm.importMethod = '';
        vm.importOpen = false;
        vm.importLoading = false;
        vm.importWaiting = false;
        vm.importError = null;
        vm.importCsvLoading = false;
        vm.csvFileName = '';
        vm.planReady = false;
        vm.planError = false;
        vm.retryLimits = retryLimits;
        vm.ideaLoading = false;
        vm.ideaError = null;
        vm.ideaCreditExhausted = false;
        vm.ideaSearched = false;
        vm.ideas = [];
        vm.ideaRows = [];
        vm.ideaFilteredRows = [];
        vm.ideaPage = 0;
        vm.ideaPages = 0;
        vm.ideaSort = {field: null, direction: 'asc'};
        vm.ideaFilters = {text: '', minVolume: '', hideAdded: true};
        vm.ideaSearch = {seed: '', seedType: 'domain'};
        vm.ideaReference = {languages: [], locations: []};
        vm.ideaReferenceLoading = false;
        vm.keywordLists = [];
        vm.keywordListsLoading = false;
        vm.importingKeywordListId = null;
        vm.importDraft = [];
        vm.tableSource = 'suggestions';
        vm.importChipLabel = '';

        vm.splitKeywordsToAdd = splitKeywordsToAdd;
        vm.addKeywordsToTrack = addKeywordsToTrack;
        vm.onKeywordDraftKeydown = onKeywordDraftKeydown;
        vm.removeKeyword = removeKeyword;
        vm.clearAllKeywords = clearAllKeywords;
        vm.keywordCapacity = keywordCapacity;
        vm.remainingKeywords = remainingKeywords;
        vm.openImportDialog = openImportDialog;
        vm.closeImportDialog = closeImportDialog;
        vm.startSearchConsoleImport = startSearchConsoleImport;
        vm.selectImport = selectImport;
        vm.searchKeywordIdeas = searchKeywordIdeas;
        vm.filterIdeas = filterIdeas;
        vm.changeIdeaPage = changeIdeaPage;
        vm.addIdea = addIdea;
        vm.addIdeaPage = addIdeaPage;
        vm.addAllIdeas = addAllIdeas;
        vm.allIdeasMonitored = allIdeasMonitored;
        vm.allSuggestionsAdded = allSuggestionsAdded;
        vm.toggleAllIdeas = toggleAllIdeas;
        vm.sortIdeas = sortIdeas;
        vm.ideaAlreadyAdded = ideaAlreadyAdded;
        vm.ideaAlreadyExisting = ideaAlreadyExisting;
        vm.hasSelectableIdeas = hasSelectableIdeas;
        vm.onImport = onImport;
        vm.importCsvFile = importCsvFile;
        vm.importKeywordList = importKeywordList;
        vm.keywordListQueryCount = keywordListQueryCount;
        vm.addImportedKeyword = addImportedKeyword;
        vm.addAllImportedKeywords = addAllImportedKeywords;
        vm.clearImportDraft = clearImportDraft;

        ctrl.$onInit = function () {
            ctrl.discoveryState = ctrl.discoveryState || {};
            ctrl.discoveryState.metrics = ctrl.discoveryState.metrics || {};
            ctrl.keywords = ctrl.keywords || [];
            ctrl.existingKeywords = ctrl.existingKeywords || [];
            vm.keywords = ctrl.keywords;
            vm.existingKeywords = ctrl.existingKeywords;
            vm.keywordMetrics = ctrl.discoveryState.metrics;
            vm.wizardMode = ctrl.wizardMode;
            vm.planReady = !!ctrl.planReady;
            vm.planError = !!ctrl.planError;
            vm.ideaSearch.seed = ctrl.suggestionDomain || '';
            if (ctrl.discoveryState.domainSearchDomain === ctrl.suggestionDomain &&
                Array.isArray(ctrl.discoveryState.domainSuggestions)) {
                vm.ideas = ctrl.discoveryState.domainSuggestions.slice();
                vm.ideaSearched = true;
            }
            refreshSelectedKeywords();

            vm.$watchCollection(function () { return ctrl.keywords; }, function () {
                refreshSelectedKeywords();
            });
            vm.$watchCollection(function () { return ctrl.existingKeywords; }, function () {
                vm.existingKeywords = ctrl.existingKeywords || [];
                refreshSelectedKeywords();
            });
            vm.$watchCollection('importDraft', function () {
                if (vm.tableSource === 'import') {
                    syncImportedTable();
                }
            });
            vm.$watch(function () { return ctrl.planReady; }, function (ready) {
                vm.planReady = !!ready;
                autoSearchProjectDomain();
            });
            vm.$watch(function () { return ctrl.planError; }, function (error) {
                vm.planError = !!error;
            });
            vm.$watch(function () { return ctrl.suggestionDomain; }, function (domain) {
                if (domain) {
                    vm.ideaSearch.seed = domain;
                    autoSearchProjectDomain();
                }
            });
            $scope.$on('socketGscKeywords', onSearchConsoleKeywords);

            trackStepView();
            initKeywordIdeas();
            $timeout(autoSearchProjectDomain, 0, false);
        };

        ctrl.$onDestroy = function () {
            destroyed = true;
        };

        function trackStepView() {
            var stoTool = 'SEO Project';
            var eventLabel = $rootScope.stoFrom ? stoTool + ' - ' + $rootScope.stoFrom : stoTool;
            if (!vm.wizardMode) {
                return;
            }
            TrackEventService.event(
                'Suite Usages',
                'SEO Project - Step - Add Keywords', eventLabel
            );
            TrackEventService.gaV2Event(
                'project_wizard', {
                    step: 'Add Keywords',
                    from: $rootScope.stoFrom,
                    type: stoTool
                }
            );
        }

        function retryLimits() {
            ctrl.onRetryLimits();
        }

        function keywordCapacity() {
            var available = Number(ctrl.suggestionLimit);
            if (!isFinite(available) || available <= 0) {
                return 0;
            }
            return Math.floor(available);
        }

        function remainingKeywords() {
            return Math.max(0, keywordCapacity() - (ctrl.keywords || []).length);
        }

        function splitKeywordsToAdd() {
            if (!vm.keywordDraft || !vm.keywordDraft.trim()) {
                return [];
            }
            var seen = Object.create(null);
            return vm.keywordDraft.trim().split(/[,\n\r]+/).reduce(function (result, rawKeyword) {
                var keyword = formatKeyword(rawKeyword);
                var lookupKey = keywordLookup(keyword);
                if (keyword && keyword.length > 1 && !selectedLookup[lookupKey] && !seen[lookupKey]) {
                    seen[lookupKey] = true;
                    result.push(keyword);
                }
                return result;
            }, []);
        }

        function addKeywordsToTrack() {
            if (!vm.planReady) {
                showCustomToast('project.wizard.keywords.limitsLoading', 'icon-x st-red');
                return;
            }
            var parsed = splitKeywordsToAdd();
            if (!parsed.length) {
                return;
            }
            var capacity = remainingKeywords();
            if (!capacity) {
                showCustomToast('project.wizard.keywords.capacityReached', 'icon-x st-red');
                return;
            }
            if (parsed.length > capacity) {
                showCustomToast('project.wizard.keywords.capacityLimited', 'icon-x st-red');
                parsed = parsed.slice(0, capacity);
            }
            parsed.forEach(function (keyword) {
                addKeyword(keyword);
            });
            vm.keywordDraft = '';
            refreshSelectedKeywords();
        }

        function onKeywordDraftKeydown(event) {
            if (event && event.keyCode === 13 && (event.ctrlKey || event.metaKey)) {
                event.preventDefault();
                addKeywordsToTrack();
            }
        }

        function removeKeyword(keyword) {
            var index = ctrl.keywords.indexOf(keyword);
            if (index !== -1) {
                ctrl.keywords.splice(index, 1);
            }
            refreshSelectedKeywords();
        }

        function clearAllKeywords() {
            ctrl.keywords.length = 0;
            refreshSelectedKeywords();
        }

        function addKeyword(keyword) {
            keyword = formatKeyword(keyword);
            if (!keyword || keyword.length < 2 ||
                ctrl.keywords.some(function (existing) {
                    return existing.toLowerCase() === keyword.toLowerCase();
                }) ||
                (ctrl.existingKeywords || []).some(function (existing) {
                    return existing.toLowerCase() === keyword.toLowerCase();
                })) {
                return false;
            }
            ctrl.keywords.push(keyword);
            return true;
        }

        function keywordLookup(keyword) {
            var formatted = formatKeyword(keyword);
            return formatted && formatted.toLowerCase();
        }

        function formatKeyword(keyword) {
            keyword = String(keyword || '');
            keyword = keyword.replace(/[!"#\$%\(\)\*\+,\:;<=>\?@\[\]\^_`{\|}~£∞·»”’¢‰›⁄¿≈⁄›¢ØŒÆ‚¯˘˚¸˝˛ˇ≥‡°¶§]/gi, '');
            keyword = keyword.trim().replace(/\s+/g, ' ').trim();
            var withoutDots = keyword.replace(/\./gi, '');
            return keyword && withoutDots ? keyword : '';
        }

        function refreshSelectedKeywords() {
            selectedLookup = Object.create(null);
            existingLookup = Object.create(null);
            (ctrl.existingKeywords || []).forEach(function (keyword) {
                existingLookup[keywordLookup(keyword)] = true;
                selectedLookup[keywordLookup(keyword)] = true;
            });
            (ctrl.keywords || []).forEach(function (keyword) {
                selectedLookup[keywordLookup(keyword)] = true;
            });
            filterIdeas();
        }

        function openImportDialog(event) {
            if (event) {
                event.stopPropagation();
            }
            if (!vm.importMethod) {
                vm.importMethod = 'csv';
            }
            vm.importOpen = true;
            vm.importError = null;
            vm.importWaiting = false;
        }

        function closeImportDialog() {
            if (vm.importLoading) {
                return;
            }
            vm.importOpen = false;
            vm.importError = null;
            vm.importWaiting = false;
        }

        function selectImport(method) {
            vm.importMethod = method;
            vm.importError = null;
            vm.importWaiting = false;
            if (method === 'saved' && !keywordListsLoaded) {
                getAllKeywordList();
            }
        }

        function startSearchConsoleImport() {
            if (vm.importLoading) {
                return;
            }
            vm.importLoading = true;
            vm.importMethod = 'search-console';
            vm.importError = null;
            SearchConsoleService.generateAuthUrl()
                .then(function (res) {
                    var url = res && res.data && res.data.url;
                    if (!url) {
                        vm.importError = 'project.wizard.ideas.error';
                        return;
                    }
                    var popup = $window.open(
                        url,
                        '_blank',
                        'location=yes,height=570,width=520,scrollbars=yes,status=yes'
                    );
                    if (!popup) {
                        vm.importError = 'project.wizard.ideas.error';
                        return;
                    }
                    vm.importWaiting = true;
                })
                .catch(function () {
                    vm.importError = 'project.wizard.ideas.error';
                })
                .finally(function () {
                    vm.importLoading = false;
                });
        }

        function onSearchConsoleKeywords(event, data) {
            var user;
            try {
                user = JSON.parse($window.localStorage.getItem('ngStorage-currentUser'));
            } catch (e) {
                user = null;
            }
            if (!data || !user || String(user.id) !== String(data.userId)) {
                return;
            }
            vm.importWaiting = false;
            var keywords = data.keywords || [];
            if (!keywords.length) {
                vm.importError = 'error.notfound.keyword';
                return;
            }
            vm.importMethod = 'search-console';
            vm.importChipLabel = 'Search Console';
            stageImportedKeywords(keywords);
        }

        function initKeywordIdeas() {
            ideaReferenceLoading = true;
            vm.ideaReferenceLoading = true;
            vm.ideaError = null;
            GoogleAdsService.getReferenceData().then(function (res) {
                if (destroyed) {
                    return;
                }
                var reference = res && res.data || {};
                vm.ideaReference = {
                    languages: reference.languages || [],
                    locations: reference.locations || []
                };
                localizeReferenceData();
                ideaReferenceLoaded = true;
                ideaReferenceLoading = false;
                vm.ideaReferenceLoading = false;
                $timeout(autoSearchProjectDomain, 0, false);
            }).catch(function () {
                if (!destroyed) {
                    vm.ideaError = 'project.wizard.ideas.referenceError';
                }
            }).finally(function () {
                if (!destroyed) {
                    ideaReferenceLoading = false;
                    vm.ideaReferenceLoading = false;
                }
            });
        }

        function autoSearchProjectDomain() {
            var domain = ctrl.suggestionDomain || vm.ideaSearch.seed;
            if (!ideaReferenceLoaded || ideaReferenceLoading ||
                vm.ideaSearched || vm.ideaLoading || !domain ||
                ctrl.discoveryState.domainSearchStartedFor === domain) {
                return;
            }
            ctrl.discoveryState.domainSearchStartedFor = domain;
            vm.ideaSearch.seed = domain;
            vm.ideaSearch.seedType = 'domain';
            searchKeywordIdeas();
        }

        function localizeReferenceData() {
            var uiLocale = $translate.use() || 'it-IT';
            var regionNames;
            var languageNames;
            if ($window.Intl && $window.Intl.DisplayNames) {
                regionNames = new $window.Intl.DisplayNames([uiLocale], {type: 'region'});
                languageNames = new $window.Intl.DisplayNames([uiLocale], {type: 'language'});
            }
            var languageCodes = {
                Italian: 'it',
                English: 'en',
                German: 'de',
                French: 'fr',
                Spanish: 'es',
                Polish: 'pl'
            };
            vm.ideaReference.languages.forEach(function (language) {
                var code = languageCodes[language.name];
                language.displayName = languageNames && code ? languageNames.of(code) : language.name;
            });
            vm.ideaReference.locations.forEach(function (location) {
                var country = (CountriesService.all() || []).filter(function (item) {
                    return item.name === location.name;
                })[0];
                location.displayName = country && regionNames ?
                    regionNames.of(country.code) || location.name : location.name;
            });
        }

        function searchKeywordIdeas() {
            if (vm.ideaLoading || ideaReferenceLoading || !vm.ideaSearch.seed.trim() ||
                !vm.ideaReference.languages.length) {
                return;
            }
            var selectedCountryCode = selectedCountryForIdeas();
            var selectedLocation = referenceLocationForCountry(selectedCountryCode);
            var selectedLanguage = referenceLanguageForUi();
            if (!selectedLocation || !selectedLanguage) {
                vm.ideaError = 'project.wizard.ideas.referenceError';
                return;
            }
            var params = {
                keywords: vm.ideaSearch.seed.trim(),
                seedType: vm.ideaSearch.seedType,
                language: selectedLanguage.id,
                location: selectedLocation.id,
                network: 'GOOGLE_SEARCH',
                matchType: 'all'
            };
            vm.ideaLoading = true;
            vm.ideaError = null;
            vm.ideaCreditExhausted = false;
            vm.ideaSearched = false;
            vm.ideas = [];
            vm.ideaRows = [];
            vm.ideaPages = 0;
            GoogleAdsService.getKeywordIdeas(params).then(function (res) {
                if (destroyed) {
                    return;
                }
                vm.ideas = ((res && res.data && res.data.keywords) || []).map(function (item) {
                    var result = {
                        keyword: item.keyword,
                        monthlySearches: item.monthlySearches,
                        monthlySearchVolumes: item.monthlySearchVolumes || []
                    };
                    vm.keywordMetrics[item.keyword] = result;
                    return result;
                });
                ctrl.discoveryState.domainSearchDomain = vm.ideaSearch.seed;
                ctrl.discoveryState.domainSuggestions = vm.ideas.slice();
                vm.ideaPage = 0;
                vm.ideaSearched = true;
                filterIdeas();
            }).catch(function (err) {
                if (destroyed) {
                    return;
                }
                var code = err && err.data && err.data.error && err.data.error.code;
                vm.ideaCreditExhausted = code === 'NO_ENOUGH_CREDITS' || code === 'NOT_IN_SUBSCRIPTION';
                vm.ideaError = code === 'NOT_IN_SUBSCRIPTION' ? 'project.wizard.ideas.unavailable'
                    : (vm.ideaCreditExhausted ? 'project.wizard.ideas.exhausted'
                    : (code === 'QUOTA_EXCEEDED' ? 'project.wizard.ideas.quota' : 'project.wizard.ideas.error'));
            }).finally(function () {
                if (!destroyed) {
                    vm.ideaLoading = false;
                }
            });
        }

        function selectedCountryForIdeas() {
            return String(ctrl.suggestionCountry ||
                $translate.use() || 'IT').slice(-2).toUpperCase();
        }

        function referenceLocationForCountry(countryCode) {
            var country = CountriesService.getByCode(countryCode);
            var englishName = country && country.name;
            if ($window.Intl && $window.Intl.DisplayNames) {
                englishName = new $window.Intl.DisplayNames(['en'], {type: 'region'})
                    .of(countryCode) || englishName;
            }
            return vm.ideaReference.locations.filter(function (location) {
                return location.name === englishName;
            })[0] || null;
        }

        function referenceLanguageForUi() {
            var locale = $translate.use() || 'it-IT';
            var language = locale.split('-')[0];
            var names = {
                it: 'Italian',
                en: 'English',
                de: 'German',
                fr: 'French',
                es: 'Spanish',
                pl: 'Polish'
            };
            return vm.ideaReference.languages.filter(function (item) {
                return item.name === names[language];
            })[0] || vm.ideaReference.languages[0];
        }

        function filterIdeas() {
            var text = (vm.ideaFilters.text || '').trim().toLowerCase();
            var filtered = (vm.ideas || []).filter(function (item) {
                return (!text || item.keyword.toLowerCase().indexOf(text) !== -1) &&
                    (!vm.ideaFilters.minVolume ||
                        (item.monthlySearches || 0) >= Number(vm.ideaFilters.minVolume)) &&
                    (!vm.ideaFilters.hideAdded || !ideaAlreadyAdded(item));
            });
            if (vm.ideaSort.field) {
                filtered.sort(function (left, right) {
                    var leftValue = vm.ideaSort.field === 'volume' ?
                        Number(left.monthlySearches) || 0 : String(left.keyword || '').toLowerCase();
                    var rightValue = vm.ideaSort.field === 'volume' ?
                        Number(right.monthlySearches) || 0 : String(right.keyword || '').toLowerCase();
                    if (leftValue === rightValue) {
                        return 0;
                    }
                    var comparison = leftValue > rightValue ? 1 : -1;
                    return vm.ideaSort.direction === 'asc' ? comparison : -comparison;
                });
            }
            vm.ideaFilteredRows = filtered;
            vm.ideaPages = Math.ceil(filtered.length / pageSize);
            vm.ideaFilteredCount = filtered.length;
            vm.ideaPage = Math.max(0, Math.min(vm.ideaPages - 1, vm.ideaPage));
            vm.ideaRows = filtered.slice(vm.ideaPage * pageSize, (vm.ideaPage + 1) * pageSize);
        }

        function changeIdeaPage(direction) {
            vm.ideaPage = Math.max(0, Math.min(vm.ideaPages - 1, vm.ideaPage + direction));
            filterIdeas();
        }

        function addIdea(idea) {
            if (!vm.planReady) {
                showCustomToast('project.wizard.keywords.limitsLoading', 'icon-x st-red');
                return;
            }
            if (remainingKeywords() <= 0) {
                showCustomToast('project.wizard.keywords.capacityReached', 'icon-x st-red');
                return;
            }
            if (addKeyword(idea.keyword)) {
                if (vm.tableSource === 'import') {
                    var importIndex = vm.importDraft.indexOf(idea.keyword);
                    if (importIndex !== -1) {
                        vm.importDraft.splice(importIndex, 1);
                    }
                    vm.ideas = vm.ideas.filter(function (item) {
                        return item.keyword !== idea.keyword;
                    });
                }
                refreshSelectedKeywords();
                if (vm.tableSource === 'import' && !vm.importDraft.length) {
                    clearImportDraft();
                }
            }
        }

        function addIdeaPage() {
            if (!vm.planReady) {
                showCustomToast('project.wizard.keywords.limitsLoading', 'icon-x st-red');
                return;
            }
            var capacity = remainingKeywords();
            if (!capacity) {
                showCustomToast('project.wizard.keywords.capacityReached', 'icon-x st-red');
                return;
            }
            vm.ideaRows.forEach(function (idea) {
                if (capacity > 0 && !ideaAlreadyAdded(idea) && addKeyword(idea.keyword)) {
                    capacity -= 1;
                }
            });
            refreshSelectedKeywords();
        }

        function addAllIdeas() {
            if (!vm.planReady) {
                showCustomToast('project.wizard.keywords.limitsLoading', 'icon-x st-red');
                return;
            }
            var capacity = remainingKeywords();
            if (!capacity) {
                showCustomToast('project.wizard.keywords.capacityReached', 'icon-x st-red');
                return;
            }
            var overflow = false;
            actionFilteredIdeas().forEach(function (idea) {
                if (ideaAlreadyAdded(idea)) {
                    return;
                }
                if (capacity > 0 && addKeyword(idea.keyword)) {
                    capacity -= 1;
                    if (vm.tableSource === 'import') {
                        var importIndex = vm.importDraft.indexOf(idea.keyword);
                        if (importIndex !== -1) {
                            vm.importDraft.splice(importIndex, 1);
                        }
                    }
                } else {
                    overflow = true;
                }
            });
            if (overflow) {
                showCustomToast('project.wizard.keywords.capacityLimited', 'icon-x st-red');
            }
            refreshSelectedKeywords();
            if (vm.tableSource === 'import' && !vm.importDraft.length) {
                clearImportDraft();
            }
        }

        function allIdeasMonitored() {
            var rows = actionFilteredIdeas().filter(function (idea) {
                return !ideaAlreadyExisting(idea);
            });
            return rows.length > 0 && rows.every(ideaAlreadyAdded);
        }

        function hasSelectableIdeas() {
            return actionFilteredIdeas().some(function (idea) {
                return !ideaAlreadyExisting(idea);
            });
        }

        function allSuggestionsAdded() {
            var suggestions = vm.ideas || [];
            return suggestions.length > 0 && suggestions.every(ideaAlreadyAdded);
        }

        function actionFilteredIdeas() {
            var text = (vm.ideaFilters.text || '').trim().toLowerCase();
            return (vm.ideas || []).filter(function (item) {
                return (!text || item.keyword.toLowerCase().indexOf(text) !== -1)
                    && (!vm.ideaFilters.minVolume ||
                        (item.monthlySearches || 0) >= Number(vm.ideaFilters.minVolume));
            });
        }

        function toggleAllIdeas() {
            if (!allIdeasMonitored()) {
                addAllIdeas();
                return;
            }
            var remove = Object.create(null);
            actionFilteredIdeas().forEach(function (idea) {
                remove[keywordLookup(idea.keyword)] = true;
            });
            for (var index = ctrl.keywords.length - 1; index >= 0; index -= 1) {
                if (remove[keywordLookup(ctrl.keywords[index])]) {
                    ctrl.keywords.splice(index, 1);
                }
            }
            refreshSelectedKeywords();
        }

        function sortIdeas(field) {
            if (vm.ideaSort.field === field) {
                vm.ideaSort.direction = vm.ideaSort.direction === 'asc' ? 'desc' : 'asc';
            } else {
                vm.ideaSort.field = field;
                vm.ideaSort.direction = field === 'volume' ? 'desc' : 'asc';
            }
            filterIdeas();
        }

        function ideaAlreadyAdded(idea) {
            return !!(idea && selectedLookup[keywordLookup(idea.keyword)]);
        }

        function ideaAlreadyExisting(idea) {
            return !!(idea && existingLookup[keywordLookup(idea.keyword)]);
        }

        function importCsvFile(file) {
            if (!file || vm.importCsvLoading) {
                return;
            }
            vm.importMethod = 'csv';
            vm.importCsvLoading = true;
            vm.importError = null;
            vm.csvFileName = file.name || '';
            if (!/\.csv$/i.test(file.name || '') || file.size > 1024 * 1024) {
                vm.importError = /\.csv$/i.test(file.name || '')
                    ? 'project.wizard.csv.file.tooLarge'
                    : 'project.wizard.csv.file.wrongType';
                vm.importCsvLoading = false;
                return;
            }
            var reader = new $window.FileReader();
            reader.onload = function (event) {
                $scope.$applyAsync(function () {
                    var keywords = keywordsFromCsvText(event.target.result);
                    vm.importCsvLoading = false;
                    if (!keywords.length) {
                        vm.importError = 'project.wizard.ideas.noMatches';
                        return;
                    }
                    onImport(keywords);
                });
            };
            reader.onerror = function () {
                $scope.$applyAsync(function () {
                    vm.importCsvLoading = false;
                    vm.importError = 'project.wizard.ideas.error';
                });
            };
            reader.readAsText(file, 'UTF-8');
        }

        function keywordsFromCsvText(text) {
            var content = String(text || '').replace(/^\uFEFF/, '').trim();
            if (!content) {
                return [];
            }
            var firstLine = content.split(/\r?\n/)[0] || '';
            var delimiter = (firstLine.match(/;/g) || []).length
                > (firstLine.match(/,/g) || []).length ? ';' : ',';
            var rows = [];
            var row = [];
            var cell = '';
            var quoted = false;

            for (var index = 0; index < content.length; index += 1) {
                var character = content[index];
                if (character === '"') {
                    if (quoted && content[index + 1] === '"') {
                        cell += '"';
                        index += 1;
                    } else {
                        quoted = !quoted;
                    }
                } else if (character === delimiter && !quoted) {
                    row.push(cell);
                    cell = '';
                } else if ((character === '\n' || character === '\r') && !quoted) {
                    if (character === '\r' && content[index + 1] === '\n') {
                        index += 1;
                    }
                    row.push(cell);
                    if (row.some(function (value) { return String(value).trim(); })) {
                        rows.push(row);
                    }
                    row = [];
                    cell = '';
                } else {
                    cell += character;
                }
            }
            row.push(cell);
            if (row.some(function (value) { return String(value).trim(); })) {
                rows.push(row);
            }
            if (!rows.length) {
                return [];
            }

            var header = rows[0].map(function (value) {
                return String(value || '').trim().toLowerCase();
            });
            var aliases = [
                'keyword', 'keywords', 'query', 'queries', 'term', 'terms',
                'termine', 'termini', 'parola chiave', 'parole chiave'
            ];
            var column = -1;
            header.some(function (value, headerIndex) {
                if (aliases.indexOf(value) !== -1) {
                    column = headerIndex;
                    return true;
                }
                return false;
            });
            var sourceRows = rows.length === 1 ? [rows[0]] : rows.slice(column === -1 ? 0 : 1);
            if (rows.length === 1) {
                return uniqueKeywords(rows[0]);
            }

            var selectedColumn = column === -1 ? 0 : column;
            return uniqueKeywords(sourceRows.map(function (cells) {
                return cells[selectedColumn];
            }));
        }

        function uniqueKeywords(values) {
            var seen = Object.create(null);
            return (values || []).reduce(function (result, rawKeyword) {
                var keyword = formatKeyword(rawKeyword);
                var lookup = keywordLookup(keyword);
                if (keyword && !seen[lookup]) {
                    seen[lookup] = true;
                    result.push(keyword);
                }
                return result;
            }, []);
        }

        function onImport(importedKeywords) {
            if (!importedKeywords || !importedKeywords.length) {
                showCustomToast('project.wizard.csv.file.is.empty', 'icon-x st-red');
                vm.importError = 'project.wizard.csv.file.is.empty';
                return;
            }
            vm.importChipLabel = 'CSV';
            stageImportedKeywords(importedKeywords);
        }

        function getAllKeywordList() {
            vm.keywordListsLoading = true;
            vm.importError = null;
            return KeywordListService.getAllKeywordList().then(function (res) {
                if (!destroyed) {
                    vm.keywordLists = res && res.data && res.data.rows || [];
                    keywordListsLoaded = true;
                }
                return res;
            }).catch(function (err) {
                $window.console.log(err);
                vm.importError = 'project.wizard.ideas.error';
            }).finally(function () {
                if (!destroyed) {
                    vm.keywordListsLoading = false;
                }
            });
        }

        function keywordListQueryCount(keywordList) {
            if (!keywordList) {
                return 0;
            }
            var count = keywordList.queriesTotalCount;
            if (count === undefined || count === null) {
                count = keywordList.queriesCount;
            }
            if (count === undefined || count === null) {
                count = keywordList.queries && keywordList.queries.length;
            }
            return Math.max(0, Number(count) || 0);
        }

        function importKeywordList(keywordList) {
            if (!keywordList || !keywordList.keywordListId || vm.importingKeywordListId) {
                return;
            }
            vm.importingKeywordListId = keywordList.keywordListId;
            vm.importError = null;
            vm.importChipLabel = keywordList && keywordList.keywordListName || 'Keyword Manager';
            KeywordListService.getOneKeywordList(keywordList.keywordListId).then(function (res) {
                var rows = res && res.data && res.data.queries && res.data.queries.rows || [];
                stageImportedKeywords(rows.map(function (row) {
                    return row.keyword;
                }));
            }).catch(function (err) {
                $window.console.log(err);
                vm.importError = 'project.wizard.ideas.error';
            }).finally(function () {
                if (!destroyed) {
                    vm.importingKeywordListId = null;
                }
            });
        }

        function stageImportedKeywords(keywords) {
            var pending = Object.create(null);
            vm.importDraft.forEach(function (keyword) {
                pending[keyword.toLowerCase()] = true;
            });
            angular.forEach(keywords || [], function (rawKeyword) {
                var keyword = formatKeyword(rawKeyword);
                var lookup = keywordLookup(keyword);
                if (keyword && keyword.length > 1 && !selectedLookup[lookup] && !pending[lookup]) {
                    pending[lookup] = true;
                    vm.importDraft.push(keyword);
                }
            });
            if (vm.importDraft.length) {
                vm.tableSource = 'import';
                vm.ideaSearched = true;
                syncImportedTable();
                vm.importOpen = false;
                vm.importError = null;
            } else {
                vm.importError = 'project.wizard.ideas.noMatches';
            }
        }

        function syncImportedTable() {
            vm.ideas = vm.importDraft.map(function (keyword) {
                return vm.keywordMetrics[keyword] || {
                    keyword: keyword,
                    monthlySearches: null,
                    monthlySearchVolumes: []
                };
            });
            vm.ideaPage = 0;
            filterIdeas();
        }

        function addImportedKeyword(index) {
            if (!vm.planReady) {
                showCustomToast('project.wizard.keywords.limitsLoading', 'icon-x st-red');
                return;
            }
            if (remainingKeywords() <= 0) {
                showCustomToast('project.wizard.keywords.capacityReached', 'icon-x st-red');
                return;
            }
            var keyword = vm.importDraft[index];
            if (keyword && addKeyword(keyword)) {
                vm.importDraft.splice(index, 1);
                vm.ideas = vm.ideas.filter(function (idea) {
                    return idea.keyword !== keyword;
                });
                refreshSelectedKeywords();
            }
        }

        function addAllImportedKeywords() {
            if (!vm.planReady) {
                showCustomToast('project.wizard.keywords.limitsLoading', 'icon-x st-red');
                return;
            }
            var capacity = remainingKeywords();
            if (!capacity) {
                showCustomToast('project.wizard.keywords.capacityReached', 'icon-x st-red');
                return;
            }
            var remainingDraft = [];
            vm.importDraft.forEach(function (keyword) {
                if (capacity > 0 && addKeyword(keyword)) {
                    capacity -= 1;
                    vm.ideas = vm.ideas.filter(function (idea) {
                        return idea.keyword !== keyword;
                    });
                } else if (ctrl.keywords.indexOf(keyword) === -1) {
                    remainingDraft.push(keyword);
                }
            });
            vm.importDraft.length = 0;
            Array.prototype.push.apply(vm.importDraft, remainingDraft);
            if (remainingDraft.length) {
                showCustomToast('project.wizard.keywords.capacityLimited', 'icon-x st-red');
            } else {
                clearImportDraft();
            }
            refreshSelectedKeywords();
        }

        function clearImportDraft() {
            vm.importDraft.length = 0;
            vm.importChipLabel = '';
            if (vm.tableSource === 'import') {
                vm.tableSource = 'suggestions';
                vm.ideas = Array.isArray(ctrl.discoveryState.domainSuggestions) ?
                    ctrl.discoveryState.domainSuggestions.slice() : [];
                vm.ideaSearched = !!vm.ideas.length;
                vm.ideaPage = 0;
                filterIdeas();
            }
        }

        function showCustomToast(string, classIcon) {
            $mdToast.show({
                template: '<md-toast layout="row" flex class="md-toast max-w">' +
                    '   <div class="p-t p-b"><i class="' + classIcon + ' m-r-sm"></i>' +
                    $translate.instant(string) + '</div>' +
                    '</md-toast>',
                hideDelay: 4000,
                position: 'top right',
                parent: angular.element('.toast-show')
            });
        }
    }

    controller.$inject = [
        '$window',
        '$scope',
        '$timeout',
        'KeywordListService',
        'TrackEventService',
        '$rootScope',
        '$mdToast',
        '$translate',
        'GoogleAdsService',
        'CountriesService',
        'SearchConsoleService',
    ];

    return {
        templateUrl: 'app/modules/project/wizard/steps/add-keywords/add-keywords.html',
        bindings: {
            keywords: '=',
            wizardMode: '<',
            suggestionDomain: '<',
            suggestionCountry: '<',
            suggestionLimit: '<',
            planReady: '<',
            planError: '<',
            onRetryLimits: '&',
            discoveryState: '<',
            existingKeywords: '<'
        },
        controller: controller,
    };
});
